'use strict';

function resizeWindow() {
    setTimeout(function () {
        equalize();
    }, 500);
}

function scrollDown() {}

scrollDownAction(20, 'scroll');

function initSlider() {
    setTimeout(function () {
        equalize({ reset: true });
    }, 500);
}

$('.filter-holder select').select2();

$(document).ready(function () {

    function _get_form_token() {
        $.get(site_url + '/ajax/functions.php?operation=_get_form_token', function (resp) {
            $("input[name=_token][type=hidden]").each(function () {
                this.value = resp;
            });
        });
    }
    $(function () {
        _get_form_token();
    });

    // WRAP MODULE TABLES
    document.querySelectorAll('.tableModule table').forEach(function (table) {
        var tableWrapper = document.createElement('div');
        tableWrapper.classList.add('tableModule_wrap');
        table.parentNode.insertBefore(tableWrapper, table);
        tableWrapper.appendChild(table);
    });

    $('#nights').removeAttr("disabled");
    $('#nights').attr("read-only", "true");

    //Call function with browser is resized.
    $(window).resize(function () {
        resizeWindow();
    });
    resizeWindow();

    //Acts when scroll down page.
    $(window).scroll(function () {
        scrollDown();
        var top = $(document).scrollTop();
        if (top > 20) {
            $('#header').addClass('scroll');
        } else {
            $('#header').removeClass('scroll');
        }
    });

    //Hashtag smooth scroll
    if (window.location.hash) {
        setTimeout(function () {
            var hash = window.location.hash;
            $('body, html').animate({
                scrollTop: $(hash).offset().top - 90
            }, 800);
        }, 500);
    }

    // Main Nav Dropdown
    $('#primary-nav').find('li').hover(function () {

        $(this).addClass("hover");
        $('ul.submenu', this).fadeIn(200);
    }, function () {

        $(this).removeClass("hover");
        $('ul.submenu', this).fadeOut(200);
    });

    $('.open-booking-widget-inline-date').on('click', function (e) {
        $("#adults").val(2);
        $("#child").val(0);
        $("#number_guest").text("2 ADULTS");
    });

    //Home page scroll down arrow. If present
    $('.arrow-home').click(function () {
        $('body, html').animate({
            scrollTop: $(window).height() - $('header').outerHeight() * 2
        }, 800, 'easeOutExpo');
    });

    setTimeout(function () {
        $('.sprite .page-view .project:nth-child(odd)').addClass('pattern');
    }, 500);

    // Home Page Map
    $('#home').find('.map-home ul.pins li').hover(function () {
        $('#home').find('.map-home ul.pins li').removeClass('active');
        $(this).addClass('active');
        $('.each-location').hide();
        $('#each-location' + $(this).attr('target')).show();
    });

    // Home Page Map
    $('#landing-page-countdown').find('.map-home ul.pins li').hover(function () {
        $('#landing-page-countdown').find('.map-home ul.pins li').removeClass('active');
        $(this).addClass('active');
        $('.each-location').hide();
        $('#each-location' + $(this).attr('target')).show();
    });

    $('.history-section').slick({
        centerMode: true,
        slidesToShow: 3,
        centerPadding: '60px',
        infinite: true,
        arrows: true,
        accessibility: false
    });

    //$('.slide-things').slick({
    //	slidesToShow: 3,
    //	slidesToScroll: 1,
    //	infinite: true,
    //	centerPadding: '60px',
    //	arrows: true,
    //	fade: false,
    //	centerMode: true,
    //	accessibility: false,
    //	asNavFor: '.slide-things-desc'
    //});
    //$('.slide-things-desc').slick({
    //	slidesToShow: 1,
    //	slidesToScroll: 1,
    //	infinite: true,
    //	arrows: false,
    //	fade: true,
    //	accessibility: false,
    //	asNavFor: '.slide-things',
    //	centerMode: true
    //});
    //$('.things[data-slide]').click(function(e) {
    //	e.preventDefault();
    //	var slideno = $(this).data('slide');
    //	$('.slide-things').slick('slickGoTo', slideno - 1);
    //});

    $(".tab-nav").slick({
        arrows: false,
        autoplay: false,
        dots: true,
        fade: true,
        appendDots: '.dots-container',
        accessibility: true,
        customPaging: function customPaging(slider, i) {
            var title = $(slider.$slides[i]).data('title');
            return '<a>' + title + '</a>';
        }
    });

    $(".tabs-menu a").hover(function (event) {
        event.preventDefault();
        $('.tabs-menu a').removeClass("active");
        $(this).addClass("active");
        var tab = $(this).attr('rel');
        $(".tab-content").not(tab).hide();
        $(tab).show();
    });

    $(".interests-menu button").click(function (event) {
        event.preventDefault();
        $('.interests-menu button').removeClass("active");
        $(this).addClass("active");
        var tab = $(this).attr("href");
        $(".tab-content").not(tab).css("display", "none");
        $(tab).fadeIn();
        setTimeout(function () {
            equalize();
        }, 50);
    });
    if ($(".interests-menu button").length > 0) {
        $(".interests-menu button:first").click();
    }

    // tablet menu
    //tablet menu
    $('.menu-trigger').click(function () {
        if ($(this).hasClass('open')) {
            $('#header .tablet-primary').fadeOut();
            var text = $(this).text();
            $('.menu-text').text('Menu');
            $('.menu-holder').removeClass('close');
        } else {
            $('#header .tablet-primary').fadeIn();
            $('.menu-text').text('Close');
            $('.menu-holder').addClass('close');
        }
    });
    $('.menu-trigger').click(function () {
        $(this).toggleClass('open');
    });

    // Open active sub-nav on load
    $('.navigation ul.submenu li .active').parents().parents('li').addClass('item-open');
    $('.navigation ul.submenu li .active').closest('.sub-sub-menu').slideDown(300, 'easeOutQuart', function () {}).addClass('menu-open');

    //Toggle open/close on tap
    $('.navigation li a').off('click').on('click', function (event) {
        if ($(this).parent().children(".sub-sub-menu").length > 0) {

            event.preventDefault();

            if ($(this).next().hasClass('menu-open')) {
                $(this).parent().parent().removeClass('open');
                $(this).parent().removeClass('item-open');
                $(this).next().slideUp(300, 'easeOutQuart').removeClass('menu-open');
                console.log("close");
            } else {
                $(this).parent().parent().addClass('open');
                $(this).parent().addClass('item-open');
                $('.sub-sub-menu.menu-open').slideUp(300, 'easeOutQuart').removeClass('menu-open');
                $(this).next().slideDown(300, 'easeOutQuart', function () {}).addClass('menu-open');
                console.log("open");
            }
        }
    });
    // Navigation Available Max-Height
    var topSiblings = $('.navigation .inner').prevAll().outerHeight() + 20; // Add 20px padding-top
    var bottomSiblings = $('.navigation .inner').nextAll().height();
    var viewportHeight = $(window).height() * 0.95; // Substract 5% for top buttons

    var navigationHeight = viewportHeight - (bottomSiblings + topSiblings);
    $('.navigation .inner > ul').css("max-height", navigationHeight);
    // Remove the mobile redirect on tablet nav
    $(".tablet-primary .navigation .inner li a").each(function () {
        this.href = this.href.replace('/m/', '/');
    });

    //Remove empty <p> tags created by tinymce
    $('p').each(function () {
        var $this = $(this);
        if ($this.html().replace(/\s|&nbsp;/g, '').length == 0) $this.remove();
    });

    $('.fancybox-copy').fancybox({
        wrapCSS: 'fullFancyCopy'
    });

    $('.directions-btn').click(function () {
        $(this).addClass('active');
        $('.directions-form-holder').fadeIn();
        $('html,body').animate({
            scrollTop: $("#directions-section").offset().top - 100
        });
        google.maps.event.addDomListener(window, 'click', initialize);
    });
    $('.directions-form-holder .close-icon').click(function () {
        $('.directions-btn').removeClass('active');
        $('.directions-form-holder').fadeOut();
    });

    $('body#specials #content .content .other-specials .each-special ul.cta a.btn, body#specials .special-window .btn').not('.nobook').html('Book Now');

    $('#specials .more-reasons').prepend('<img src="https://2486634c787a971a3554-d983ce57e4c84901daded0f67d5a004f.ssl.cf1.rackcdn.com/the-bristol-hotel/media/quad-texture-5afb31ffe6f32.png" alt="Lower tan texture" class="texture">');

    //Event Tracking
    //this class should be add to any link to the booking engine
    //GA parametters :  ga('send', 'event', [eventCategory], [eventAction], [eventLabel]);
    $('.book-now').on('click', function () {
        if (typeof ga == 'function') ga('send', 'event', 'reservations', 'click', 'book now');
    });
    //this class should be add to the header widget submit button
    $('.bookNow').on('click', function () {
        if (typeof ga == 'function') ga('send', 'event', 'header widget', 'click', 'book now');
    });

    //Check in and check out datepicker for booking engine
    $("#CheckIn").datepicker({
        //showOn: "both",
        //buttonImage: SITE_FILES+"images/img-calendar-gray.png",
        //buttonImageOnly: true,
        changeMonth: true,
        numberOfMonths: 1,
        minDate: 0,
        onSelect: function onSelect(selectedDate) {
            var getDate = $(this).datepicker('getDate');
            var newDate = new Date(getDate.getTime());
            newDate.setDate(newDate.getDate() + 3);
            $("#CheckOut").datepicker("setDate", newDate);
            $("#CheckOut").datepicker("option", "minDate", selectedDate);
        }
    });
    $("#CheckOut").datepicker({
        //showOn: "both",
        //buttonImage: SITE_FILES+"images/img-calendar-gray.png",
        //buttonImageOnly: true,
        changeMonth: true,
        numberOfMonths: 1,
        onSelect: function onSelect(selectedDate) {
            //$( "#CheckIn" ).datepicker( "option", "maxDate", selectedDate );
        }
    });

    ////Temporary booking widget
    //jQuery('.reserve-form').submit(function(event) {
    //	event.preventDefault();
    //	let checkIn = jQuery(this).find('[name="booking-checkin"]');
    //	let checkOut = jQuery(this).find('[name="booking-checkout"]');
    //	let checkInVal = checkIn.val();
    //	let checkOutVal = checkOut.val();
    //	let checkInArray = checkInVal.split('/');
    //	let checkOutArray = checkOutVal.split('/');
    //	let checkInYear = checkInArray[2];
    //	let checkInMonth = parseInt(checkInArray[0]) - 1;
    //	let checkInMonthAdj = checkInArray[0];
    //	let checkInDay = checkInArray[1];
    //	let checkOutYear = checkOutArray[2];
    //	let checkOutMonth = parseInt(checkOutArray[0]) - 1;
    //	let checkOutDay = checkOutArray[1];
    //	//calculate number of days chosen
    //	let oneDay = 24*60*60*1000; // hours*minutes*seconds*milliseconds
    //	let checkInDate = new Date(checkInYear,checkInMonth,checkInDay);
    //	let checkOutDate = new Date(checkOutYear,checkOutMonth,checkOutDay);
    //	let numDays = Math.round(Math.abs((checkInDate.getTime() - checkOutDate.getTime())/(oneDay)));
    //	//validation
    //	if (checkInDate >= checkOutDate) {
    //		alert('Your Check-out day must be after your Check-in day. Please check your selection and try again.');
    //		return false;
    //	}
    //	//promo code
    //	let promoCode = jQuery(this).find('[name="promo-code"]');
    //	let promoCodeVal = promoCode.val();
    //	//go to booking URL
    //	let bookingURL = 'https://www.bookonthenet.net/east/premium/eresmain.aspx?id=zXLWlo7LcuWAkNpkhpfj6zT7OcrU9fsRXDHud%2fLdmbg%3d&arrival_date='+ checkInMonthAdj +'%2F'+ checkInDay +'%2F'+ checkInYear +'&stay_nights='+ numDays +'&promo_code='+ promoCodeVal +'&adults=2&children=0&x=28&y=14';
    //	window.location.assign(bookingURL);
    //});

    // Map: Return to previous page button. Change body id to match map template's name.
    $('body#map-category #content').prepend('<a class="btn return-from-map" href="javascript:history.back()">« Back to previous page</a>');

    //Landing Page
    $('#landing-page-countdown .landing-form input[name="promo"]').attr('name', 'identifier');

    function playVideo() {

        var video = document.querySelector('#header-video video'),
            buttonPlay = document.querySelector('#play-video'),
            text = document.querySelector('.play p');
        if (buttonPlay) {
            buttonPlay.addEventListener('click', function () {
                video.play();
                video.controls = true;
                buttonPlay.classList.add('remove');
                text.classList.add('remove');
            });
        }
    }
    playVideo();

    var figure = $(".hover-video").hover(hoverVideo, hideVideo);

    function hoverVideo(e) {
        $('video', this).get(0).play();
    }

    function hideVideo(e) {
        $('video', this).get(0).pause();
    }

    $('a[href$="https://www.bristolhotelva.com/concert-packages"]').text("Learn More");

    $('.sym-slides').slick({
        accessibility: true
    });

    if ($('.events-upcoming_item').length <= 3) {
        $('.events-upcoming_item').addClass('no-slider');
    }
});

function getMenu(menu_id) {
    $.get(site_url + 'ajax/functions.php', {
        operation: "getMenu",
        menu_id: menu_id
    }, function (data) {
        $.fancybox(data);
    });
}

function getLumac(menu_id1, menu_id2, menu_id3) {
    $.get(site_url + 'ajax/functions.php', {
        operation: "getLumac",
        menu_id1: menu_id1,
        menu_id2: menu_id2,
        menu_id3: menu_id3
    }, function (data) {
        $.fancybox(data, {
            afterShow: function afterShow() {
                $('.popup-overlay').hide();
            }
        });
    });
}

$(window).on('load', function () {
    equalize();
});

// ADA: Attractionns CTA adjustment
setTimeout(function () {
    var attractionsCta = document.querySelectorAll('.learn-more-btn');
    var attractionTitle = document.querySelectorAll('.attraction__info h2');
    attractionsCta.forEach(function (cta, index) {
        var titleText = attractionTitle[index].textContent.toLowerCase();
        cta.textContent = 'read more';
        cta.setAttribute('aria-label', 'Read more about ' + titleText);
    });
}, 500);